var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            width: "80%",
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "inputForm",
                      class: _vm.method === "view" ? "readonly" : "",
                      attrs: {
                        model: _vm.inputForm,
                        size: "small",
                        disabled: _vm.method === "view",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 15 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "中文名称：", prop: "" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.inputForm.nameCn)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "英文名称：", prop: "" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.inputForm.name)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "物品编码：", prop: "" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.inputForm.code)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "分类：", prop: "" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.inputForm.category.name)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "当前物品类别：",
                                    prop: "itemPeroperty",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.inputForm.category.parentIdsName
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "价格：", prop: "price" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$mathUtil.mathToFixed(
                                          _vm.inputForm.price
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "库存单位：", prop: "unit" },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.inputForm.units.unitEn)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "属性：",
                                    prop: "itemPeroperty",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.setItemPeropertyText(
                                          _vm.inputForm.itemPeroperty
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "描述：",
                                    prop: "description",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.inputForm.code)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                "padding-left": "0px",
                                "padding-right": "0px",
                              },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "jsonStr",
                                  class:
                                    _vm.method === "view" ? "readonly" : "",
                                  attrs: {
                                    model: _vm.jsonStr,
                                    disabled: _vm.method === "view",
                                    "label-width": "142px",
                                  },
                                },
                                _vm._l(_vm.fieldList2, function (field) {
                                  return _c(
                                    "el-col",
                                    {
                                      key: field.id,
                                      staticStyle: {
                                        "padding-left": "0px",
                                        "padding-right": "0px",
                                      },
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _c("el-form-item", {
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          prop: field.id + ".fieldType",
                                        },
                                      }),
                                      field.itemAgileField != "" &&
                                      !field.itemAgileField == false
                                        ? [
                                            _c(
                                              "el-col",
                                              {
                                                style:
                                                  field.itemAgileField
                                                    .haveUnit == "1" ||
                                                  field.itemAgileField
                                                    .fieldType == "3"
                                                    ? "display: contents;"
                                                    : "",
                                                attrs: {
                                                  span:
                                                    field.itemAgileField
                                                      .haveUnit == "1" ||
                                                    field.itemAgileField
                                                      .fieldType == "3"
                                                      ? 16
                                                      : 12,
                                                },
                                              },
                                              [
                                                field.itemAgileField != "" &&
                                                field.itemAgileField
                                                  .fieldType == "3"
                                                  ? [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          staticStyle: {
                                                            float: "left",
                                                            "padding-left":
                                                              "7.5px",
                                                          },
                                                          attrs: {
                                                            rules:
                                                              _vm.isNotRequire(
                                                                field
                                                              )
                                                                ? [
                                                                    {
                                                                      validator:
                                                                        _vm
                                                                          .validator
                                                                          .isFloatGtZero,
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ]
                                                                : [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "不能为空",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                    {
                                                                      validator:
                                                                        _vm
                                                                          .validator
                                                                          .isFloatGtZero,
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ],
                                                            prop:
                                                              field.id + ".en",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                slot: "label",
                                                              },
                                                              slot: "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    field.nameEn
                                                                  ) +
                                                                  " "
                                                              ),
                                                              field.note != ""
                                                                ? void 0
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                          _c("el-input", {
                                                            staticClass:
                                                              "inline-input",
                                                            style:
                                                              field
                                                                .itemAgileField
                                                                .haveUnit == "1"
                                                                ? "width: 100px !important;"
                                                                : "width: 185px !important;",
                                                            attrs: {
                                                              placeholder:
                                                                "数字1",
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.jsonStr[
                                                                  field.id
                                                                ].en,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.jsonStr[
                                                                      field.id
                                                                    ],
                                                                    "en",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "jsonStr[field.id].en",
                                                            },
                                                          }),
                                                          _vm._v(" ~ "),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          staticStyle: {
                                                            float: "left",
                                                          },
                                                          attrs: {
                                                            rules:
                                                              _vm.isNotRequire(
                                                                field
                                                              )
                                                                ? [
                                                                    {
                                                                      validator:
                                                                        _vm
                                                                          .validator
                                                                          .isFloatGtZero,
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ]
                                                                : [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "不能为空",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                    {
                                                                      validator:
                                                                        _vm
                                                                          .validator
                                                                          .isFloatGtZero,
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ],
                                                            prop:
                                                              field.id + ".ch",
                                                            "label-width":
                                                              "5px",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            staticClass:
                                                              "inline-input",
                                                            style:
                                                              field
                                                                .itemAgileField
                                                                .haveUnit == "1"
                                                                ? "width: 100px !important;"
                                                                : "width: 185px !important;",
                                                            attrs: {
                                                              placeholder:
                                                                "数字2",
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.jsonStr[
                                                                  field.id
                                                                ].ch,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.jsonStr[
                                                                      field.id
                                                                    ],
                                                                    "ch",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "jsonStr[field.id].ch",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : field.itemAgileField
                                                      .fieldType == "2"
                                                  ? [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          staticStyle: {
                                                            float: "left",
                                                            "padding-left":
                                                              "7.5px",
                                                          },
                                                          attrs: {
                                                            rules:
                                                              _vm.isNotRequire(
                                                                field
                                                              ) ||
                                                              _vm.isNumNotRequire
                                                                ? [
                                                                    {
                                                                      validator:
                                                                        _vm
                                                                          .validator
                                                                          .isFractionAndCustom,
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ]
                                                                : [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "不能为空",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                    {
                                                                      validator:
                                                                        _vm
                                                                          .validator
                                                                          .isFractionAndCustom,
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ],
                                                            prop:
                                                              field.id + ".en",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                slot: "label",
                                                              },
                                                              slot: "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    field.nameEn
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "content-box",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.jsonStr[
                                                                      field.id
                                                                    ].en
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            span: 24,
                                                            rules:
                                                              _vm.isNotRequire(
                                                                field
                                                              )
                                                                ? []
                                                                : [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "不能为空",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                    {
                                                                      min: 1,
                                                                      message:
                                                                        "最小长度是1个字符",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ],
                                                            prop:
                                                              field.id + ".en",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                slot: "label",
                                                              },
                                                              slot: "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    field.nameEn
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "content-box",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.jsonStr[
                                                                      field.id
                                                                    ].en
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                field.itemAgileField.haveUnit ==
                                                "1"
                                                  ? [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          staticStyle: {
                                                            float: "left",
                                                          },
                                                          attrs: {
                                                            prop:
                                                              field.id +
                                                              ".unit",
                                                            "label-width":
                                                              "10px",
                                                            rules:
                                                              _vm.isNotRequire(
                                                                field
                                                              ) ||
                                                              _vm.isNumNotRequire
                                                                ? []
                                                                : [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "不能为空",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ],
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.BackUnitName(
                                                                  _vm.getUnitList(
                                                                    field
                                                                      .itemAgileField
                                                                      .unitCategory
                                                                  ),
                                                                  _vm.jsonStr[
                                                                    field.id
                                                                  ].unit
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                            field.itemAgileField.fieldType ==
                                            "1"
                                              ? _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          prop:
                                                            field.id + ".ch",
                                                          "label-width":
                                                            "108px",
                                                          span: 24,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              slot: "label",
                                                            },
                                                            slot: "label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  field.name
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "content-box",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.jsonStr[
                                                                    field.id
                                                                  ].ch
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("ImageColumn", {
                    attrs: {
                      imageArray: _vm.inputForm.picJsonList,
                      code: _vm.inputForm.code,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }